export default {
    token: null,
    user: null,
    adminPanel: false,
    companyLicence: {},
    selectedReportLanguages: [],
    navbarOpen: true,
    queued_jobs: [],
    fulfilled_jobs: [],
    app_state: null,
}